import prepare from '@drivesally/sally-fw/lib/attribute/prepare.attribute';

export default (attributes) => {
  const prepared = prepare(attributes, {
    field: 'api',
    required: ['repo_reason'],
    // required: ['repo_type', 'repo_outcome', 'repo_reason'],
  });
  // Convert rent_after_balance_is_paid from 'yes'/'no'/'na' to boolean | null
  if (prepared.rent_after_balance_is_paid !== undefined) {
    prepared.rent_after_balance_is_paid =
      prepared.rent_after_balance_is_paid === 'yes'
        ? true
        : prepared.rent_after_balance_is_paid === 'no'
          ? false
          : null;
  }
  return prepared;
};
